<template>
  <div class="app-container" style="padding:30px 100px;">
    <el-form :model="data" ref="addForm" label-width="90px">
      <el-form-item label="内容标题:" prop="name">{{data.title}}</el-form-item>
      <el-form-item label="类型:" prop="name">{{data.contentType === 1 ? '图文' : '视频'}}</el-form-item>
      <el-form-item label="封面图:" prop="name">
        <el-image v-for="item in data.headPicUrlList" style="width: 100px;margin-right: 5px"
          :src="item" :preview-src-list="[item]" fit="contain"/>
      </el-form-item>
      <el-form-item label="列表排版:" v-if="data.articleType === 1 && data.contentType === 1" prop="name">{{data.listStyleDesc}}</el-form-item>
      <el-form-item label="视频文件:" prop="name" v-if="data.articleType === 1 && data.contentType === 2">
        <video controls="controls" preload  style="width: 300px; height: 300px;background:#eee;">
          <source :src="data.videoUrl" >
        </video>
      </el-form-item>
      <el-form-item label="排序:" prop="name">{{data.tenantSortNo}}</el-form-item>
      <el-form-item v-if="data.articleType === 1" label="标签:" prop="name">{{data.tags}}</el-form-item>
      <el-form-item label="简介:" prop="introduction" v-if="data.articleType === 1 && data.contentType === 2">
        <div v-html="data.introduction"></div>
      </el-form-item>
      <el-form-item label="详情:" class="ueditor" prop="content" v-else>
        <el-card shadow="never">
          <div v-html="data.content"></div>
        </el-card>
      </el-form-item>
      <el-form-item prop="introduction">
        <el-button @click="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { articleDetail } from "@/api/saas/package";
import { mapState } from 'vuex'
export default {
  components: {
  },
  data() {
    return {
      disabled: true,
      articleId: null,
      data: {
        title: "这是一个文章",
        contentType: 2,
        headPicUrl:
          "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        detail: "这是详情内容"
      },
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  mounted() {
    this.articleId = this.$route.query.id;
    this.articleDetail();
  },
  methods: {
    articleDetail() {
      articleDetail({ articleId: this.articleId })
        .then(response => {
          this.$nextTick(() => {
            this.data = response.data
          })
        })
        .catch(error => {});
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.ueditor {
  ::v-deep .el-form-item__content{
    line-height: unset !important;
  }
}
</style>
